import { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { PATH_URL } from 'src/helpers'
import { getQueryParameters } from 'src/helpers/tool'
import { preserveUrlParams } from 'src/helpers/preserveUrlParams'
import { BudgetOption } from './constants'

export const useExpectedBudget = () => {
  const history = useHistory()
  const [selectedBudget, setSelectedBudget] = useState<BudgetOption | null>(null)

  // Check for collectionId parameter and save it to collectionsQuizEntry
  useEffect(() => {
    const params = getQueryParameters()
    const collectionId = params.get('collectionId')

    if (collectionId) {
      console.log('Collection ID detected in ExpectedBudgetPage, saving to collectionsQuizEntry')
      const collectionsQuizEntry = JSON.parse(localStorage.getItem('collectionsQuizEntry') || '{}')
      collectionsQuizEntry.collectionId = collectionId
      localStorage.setItem('collectionsQuizEntry', JSON.stringify(collectionsQuizEntry))
    }
  }, [])

  const handleSelectBudget = useCallback((budget: BudgetOption) => {
    setSelectedBudget(budget)
  }, [])

  const handleSubmit = useCallback(() => {
    if (!selectedBudget) return

    try {
      const collectionsQuizEntry = localStorage.getItem('collectionsQuizEntry')
      if (!collectionsQuizEntry) {
        console.warn('collectionsQuizEntry not found in localStorage')
        return
      }

      const currentData = JSON.parse(collectionsQuizEntry)

      // Lưu expectedBudget vào quizResponses (thống nhất với NewFlow)
      const quizResponses = currentData.quizResponses || []
      const budgetIndex = quizResponses.findIndex((item: any) => item.key === 'BUDGET')
      const updatedQuizResponses =
        budgetIndex > -1
          ? quizResponses.map((item: any, index: number) =>
              index === budgetIndex ? { ...item, values: selectedBudget } : item
            )
          : [...quizResponses, { key: 'BUDGET', values: selectedBudget }]

      currentData.expectedBudget = selectedBudget
      currentData.quizResponses = updatedQuizResponses

      // Ensure collectionId is saved if present
      const params = getQueryParameters()
      const collectionId = params.get('collectionId')
      if (collectionId) {
        currentData.collectionId = collectionId
      }

      localStorage.setItem('collectionsQuizEntry', JSON.stringify(currentData))

      // Use preserveUrlParams to maintain query parameters
      // Removed party count and table count pages
      const nextUrl = preserveUrlParams(PATH_URL.COLLECTIONS_QUIZ_FLORAL_PLANNING)
      history.push(nextUrl)
    } catch (err) {
      console.warn('Failed to update expected budget in localStorage:', err)
    }
  }, [selectedBudget, history])

  return {
    selectedBudget,
    handleSelectBudget,
    handleSubmit,
    isValid: selectedBudget !== null,
  }
}
